module.exports = __webpack_public_path__ + "static/media/26_A.56d36d66.png";